(function () {
    'use strict';

    const reduceMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
    ).matches;

    // ======================================================
    // ACCORDION
    // ======================================================
    const accItems = document.querySelectorAll('.acc-item');

    function openAccItem(item) {
        accItems.forEach((other) => {
            other.setAttribute(
                'aria-expanded',
                other === item ? 'true' : 'false'
            );
        });
        // Note: intentionally NO scrollTo here. Accordion opens in place
        // so the user's scroll position is preserved.
    }

    function closeAccItem(item) {
        item.setAttribute('aria-expanded', 'false');
    }

    accItems.forEach((item) => {
        const header = item.querySelector('.acc-header');
        if (!header) return;
        header.addEventListener('click', () => {
            const isOpen = item.getAttribute('aria-expanded') === 'true';
            if (isOpen) {
                // Clicking an open item closes it. The toggle reads "×" so close behavior
                // matches the affordance.
                closeAccItem(item);
            } else {
                // Opening this item also closes any others that were open (one-at-a-time).
                openAccItem(item);
            }
        });
        header.addEventListener('keydown', (e) => {
            if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
                e.preventDefault();
                const all = Array.from(accItems);
                const idx = all.indexOf(item);
                const next =
                    e.key === 'ArrowDown'
                        ? (idx + 1) % all.length
                        : (idx - 1 + all.length) % all.length;
                all[next].querySelector('.acc-header').focus();
            }
        });
    });

    // ======================================================
    // HERO PATHWAYS + TEMP STRIP TICKS — open matching accordion item
    // ======================================================
    const heroLinks = document.querySelectorAll('.hero__path, .temp-tick');
    heroLinks.forEach((link) => {
        link.addEventListener('click', (e) => {
            const href = link.getAttribute('href') || '';
            const targetId = href.replace('#', '');
            const targetItem = document.getElementById(targetId);
            if (targetItem && targetItem.classList.contains('acc-item')) {
                e.preventDefault();
                openAccItem(targetItem);
                // Small delay lets the accordion start opening before we scroll,
                // so the final position accounts for the expanded panel height.
                setTimeout(() => {
                    targetItem.scrollIntoView({
                        behavior: reduceMotion ? 'instant' : 'smooth',
                        block: 'start',
                    });
                }, 50);
            }
        });
    });

    // Also handle direct hash navigation (e.g. /pages/fabrics#luxe loads with luxe open)
    function openFromHash() {
        const hash = window.location.hash.replace('#', '');
        if (!hash) return;
        const target = document.getElementById(hash);
        if (target && target.classList.contains('acc-item')) {
            openAccItem(target);
        }
    }
    openFromHash();
    window.addEventListener('hashchange', openFromHash);

    // ======================================================
    // BREAKDOWN TABLE TOGGLE (Polos / Quarter-Zips)
    // ======================================================
    const tabs = document.querySelectorAll('.breakdown__toggle button');
    const tables = document.querySelectorAll('.breakdown__table');

    tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
            const target = tab.dataset.target;
            tabs.forEach((t) =>
                t.setAttribute('aria-selected', t === tab ? 'true' : 'false')
            );
            tables.forEach((table) => {
                if (table.dataset.table === target)
                    table.removeAttribute('hidden');
                else table.setAttribute('hidden', '');
            });
        });
        tab.addEventListener('keydown', (e) => {
            if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
            e.preventDefault();
            const idx = Array.from(tabs).indexOf(tab);
            const next =
                e.key === 'ArrowRight'
                    ? (idx + 1) % tabs.length
                    : (idx - 1 + tabs.length) % tabs.length;
            tabs[next].focus();
            tabs[next].click();
        });
    });

    // ======================================================
    // ACCORDION IMAGE TOGGLE (Polo / 1/4 Zip on Infinity + Luxe)
    // ======================================================
    document.querySelectorAll('.acc-media-stack').forEach((stack) => {
        const buttons = stack.querySelectorAll('.acc-media-toggle button');
        const variants = stack.querySelectorAll(
            '.acc-media-variants .acc-media'
        );
        buttons.forEach((btn) => {
            btn.addEventListener('click', () => {
                const target = btn.dataset.target;
                buttons.forEach((b) =>
                    b.setAttribute('aria-pressed', b === btn ? 'true' : 'false')
                );
                variants.forEach((v) =>
                    v.setAttribute(
                        'data-active',
                        v.dataset.variant === target ? 'true' : 'false'
                    )
                );
            });
            btn.addEventListener('keydown', (e) => {
                if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
                e.preventDefault();
                const arr = Array.from(buttons);
                const idx = arr.indexOf(btn);
                const next =
                    e.key === 'ArrowRight'
                        ? (idx + 1) % arr.length
                        : (idx - 1 + arr.length) % arr.length;
                arr[next].focus();
                arr[next].click();
            });
        });
    });

    // ======================================================
    // HERO STAGGER REVEAL on load
    // ======================================================
    if (!reduceMotion) {
        const heroEls = [
            document.querySelector('.hero__copy .eyebrow'),
            document.querySelector('.hero__copy h1'),
            document.querySelector('.hero__sub'),
            document.querySelector('.hero__cta'),
            document.querySelector('.hero__paths'),
            document.querySelector('.temp-strip'),
            document.querySelector('.hero__strip'),
        ].filter(Boolean);

        heroEls.forEach((el, i) => {
            el.style.opacity = '0';
            el.style.transform = 'translateY(12px)';
            el.style.transition =
                'opacity 0.7s cubic-bezier(0.16, 1, 0.3, 1), transform 0.7s cubic-bezier(0.16, 1, 0.3, 1)';
            el.style.transitionDelay = `${i * 0.08}s`;
        });

        // Trigger after one tick
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                heroEls.forEach((el) => {
                    el.style.opacity = '1';
                    el.style.transform = 'translateY(0)';
                });
            });
        });
    }
})();
